import { BreadcrumbSize } from './Breadcrumb.types';

type BreadcrumbConstsType = {
  [size in BreadcrumbSize]: {
    margin: string;
    heading: 'h11' | 'h14';
    iconSize: string;
  };
};

export const breadcrumbConsts: BreadcrumbConstsType = {
  small: {
    margin: '4px 0px',
    heading: 'h11',
    iconSize: '16px',
  },
  medium: {
    margin: '4px 0px',
    heading: 'h14',
    iconSize: '20px',
  },
};
